import React from 'react';
import PropTypes from 'prop-types';

import styles from './Charts.module.scss';

const ChartLegend = React.memo(({ legends }) => {
  return (
    <div className="flex justify-center mt1">
      {legends.map((legend) => (
        <div className="flex items-center" key={legend.title}>
          <span className={`inline-block ${legend.color} ${styles.rounded_full}`} />
          <span className={`inline-block ${styles.chart_legend}`}>{legend.title}</span>
        </div>
      ))}
    </div>
  );
});

ChartLegend.propTypes = {
  legends: PropTypes.arrayOf(PropTypes.any),
};

ChartLegend.defaultProps = {
  legends: undefined,
};

export default ChartLegend;
